export default "<button class=\"btn btn-ghost mr1\" ng-click=\"$ctrl.resetSearch()\" twp-translate>\n  RESET_SEARCH\n</button>\n";